import ResourceModelBase from 'odd-resource_model'
import axios from 'axios'

const OPTIONS = {
  apiPath: '/api',
  apiVersion: 'v1',
  scope: 'web',
  resourceType: 'shipping_methods',
  attributes: [
    'id',
    'name',
    'enabled',
    'rate_type',
    'rate_rule',
    'is_default',
    'shipping_categories',
    'gateway_type',
    'shipment_type_detail',
  ],
  editableAttributes: [
    'name',
    'enabled',
    'rate_type',
    'rate_rule',
    'shipping_category_ids',
    'gateway_type',
    'shipment_type_detail',
  ],
}

export default class ShippingMethod extends ResourceModelBase {
  constructor(attributes = {}) {
    super(OPTIONS, attributes)
  }

  static fetchGateways() {
    return axios.get(`${new this().apiBasePath({ withResourceType: false })}/logistic_gateways`)
  }

  static configGateway(gateway) {
    let requestBody = {
      data: {
        type: 'gateway_config',
        attributes: {
          provider: gateway.provider,
        },
      },
    }

    gateway.required_fields.forEach((field) => (requestBody.data.attributes[field] = gateway[field]))

    return axios.put(
      `${new this().apiBasePath({ withResourceType: false })}/logistic_gateways/${gateway.provider}`,
      requestBody
    )
  }

  static removeGatewayConfigurations(gateway) {
    return axios.delete(`${new this().apiBasePath({ withResourceType: false })}/logistic_gateways/${gateway.provider}`)
  }

  toggle() {
    return axios.put(`${this.apiBasePath()}/${this.id}/toggle`)
  }

  static fetchRateTypes() {
    return axios.get(`${new this().apiBasePath()}/rate_types`)
  }

  // extra methods or helpers here...
  static rateRuleTemplate(rateType) {
    switch (rateType) {
      case 'flat':
        return {
          price: '',
        }
      case 'flat_per_item':
        return {
          price: '',
        }
    }
  }

  displayRateRule() {
    return I18n.t(`copies.shipping_fee_rate_rules.${this.rate_type}`, this.rate_rule)
  }

  isCvsLogistic() {
    return ['fami_b2c', 'fami_c2c', 'unimart_b2c', 'unimart_c2c', 'hilife_b2c', 'hilife_c2c'].includes(
      this.shipment_type_detail.shipping_type
    )
  }

  isStoreLogistic() {
    return this.shipment_type_detail.shipping_type === 'store'
  }

  isHomeLogistic() {
    return !this.isStoreLogistic() && !this.isCvsLogistic()
  }

  isOverseaLogistic() {
    return this.shipment_type_detail.shipping_type === 'oversea'
  }
}
